export const BREAKPOINTS = {
  xxl: "min-width: 1920px",
  xl: "min-width: 1440px",
  lg: "min-width: 992px",
  md: "min-width: 768px",
  xs: "max-width: 450px",
  sm: "min-width: 320px",
};
